import React, { useEffect, useRef } from 'react'
import sanitizeHtml from 'sanitize-html'
import styled from 'styled-components'

const StyledRichText = styled.div`
  img{
    max-width:96%;
    max-height:300px;
    display:block;
    margin: 10px auto;
    cursor: pointer;
  }
  p {
    white-space: pre-line;
    display: block;
    margin: 10px 0;
  }
  a {
    color: var(--chakra-colors-primary-fg);
    text-decoration: underline;
  }
  .dark a {
    color: var(--chakra-colors-primary-400);
  }
`

export default function RichTextViewer ({ content, style, className }) {
  const containerRef = useRef(null)

  useEffect(() => {
    const el = containerRef.current
    if (!el) return

    const handleClick = (event) => {
      const target = event.target
      if (!target) return

      const img = target.closest?.('img')
      if (!img) return

      const src = img.getAttribute('src')
      if (!src) return

      window.open(src, '_blank', 'noopener,noreferrer')
    }

    el.addEventListener('click', handleClick)
    return () => el.removeEventListener('click', handleClick)
  }, [])

  if (!content) return null
  return (
    <StyledRichText>
      <p
        ref={containerRef}
        style={{ style }}
        className={`${className}`}
        dangerouslySetInnerHTML={{
          __html:
        sanitizeHtml(content, {
          allowedTags: sanitizeHtml.defaults.allowedTags.concat(['img', 'u']),
          allowedAttributes: {
            a: ['href', 'name', 'target'],
            img: ['src']
          },
          transformTags: {
            a (tagName, attribs) {
              return {
                tagName: 'a',
                attribs: {
                  href: attribs.href,
                  target: '_blank',
                  rel: 'noopener noreferrer'
                }
              }
            }
          }
        })
        }}
      />
    </StyledRichText>
  )
}
